// import { useState } from "react";
// import { Box, IconButton, Typography } from "@mui/material";
// import { motion, AnimatePresence } from "framer-motion";

// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import { ChartWithLoader } from "./ChartWithLoader";

// export const ChartSlider = ({ charts = [] }) => {
//   const [index, setIndex] = useState(0);
//   const [direction, setDirection] = useState(0);

//   const paginate = (newDirection) => {
//     setDirection(newDirection);

//     setIndex((prev) => {
//       if (newDirection === 1) {
//         return prev === charts.length - 1 ? 0 : prev + 1;
//       } else {
//         return prev === 0 ? charts.length - 1 : prev - 1;
//       }
//     });
//   };

//   const activeChart = charts[index];
//   return (
//     <Box sx={{ textAlign: "center", width: "100%" }}>

//       {/* Chart area with overflow hidden */}
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           minHeight: "350px",
//           overflow: "hidden",      // <<<<<< FIX horizontal overflow here
//           minWidth: 200,
//           minHeight: 200,
//         }}
//       >
//         <AnimatePresence initial={false} custom={direction}>
//           <motion.div
//             key={activeChart.title}
//             custom={direction}
//             initial={{ x: direction > 0 ? 300 : -300, opacity: 0 }}
//             animate={{ x: 0, opacity: 1 }}
//             exit={{ x: direction > 0 ? -300 : 300, opacity: 0 }}
//             transition={{ duration: 0.4, ease: "easeInOut" }}
//             style={{
//               position: "absolute",
//               width: "100%",
//               top: 0,
//               left: 0,
//             }}
//           >
//             <ChartWithLoader
//               url={activeChart.url}
//               title={activeChart.title}
//               loading={activeChart.loading}
//               show={activeChart.show}
//             />
//           </motion.div>
//         </AnimatePresence>
//       </Box>

//       {/* Navigation Buttons */}
//       <Box sx={{ display: "flex", justifyContent: "center", gap: 1}}>
//         <IconButton onClick={() => paginate(-1)}>
//           <ArrowBackIosNewIcon fontSize="small"/>
//         </IconButton>

//         <IconButton onClick={() => paginate(1)}>
//           <ArrowForwardIosIcon fontSize="small"/>
//         </IconButton>
//       </Box>

//       <Typography sx={{ color: "gray", mt: 1, fontSize: "12" }}>
//         {index + 1} / {charts.length}
//       </Typography>
//     </Box>
//   );
// };

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ChartWithLoader } from "./ChartWithLoader";
import { useRef } from "react";

export const ChartSlider = ({ charts = [],minWidth = 225, maxWidth=250, minheight=170, ...props }) => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,          // we will use custom MUI arrows below
    infinite: true,
    speed: 500,
    slidesToShow: 1,        // show one chart at a time
    slidesToScroll: 1,
    adaptiveHeight: true,
    swipeToSlide: true,
  };

  return (
    <Box sx={{ minWidth, maxWidth, minHeight : minheight}}>

      {/* Slick Slider */}
      <Slider ref={sliderRef} {...settings}>
        {charts.map((chart, idx) => (
          // <Box key={idx} sx={{ width: "100%" }}>
          <ChartWithLoader
            maxWidth={maxWidth}
            minWidth={minWidth}
            minHeight={minheight}
            url={chart.url}
            title={chart.title}
            loading={chart.loading}
            show={chart.show}
          />
          // </Box>
        ))}
      </Slider>

      {/* Bottom Nav Buttons */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 0, gap: 1 }}>
        <IconButton
          onClick={() => sliderRef.current.slickPrev()}
          size="small"
          sx={{
            p: 0.5,
            bgcolor: "grey.100",
            borderRadius: "8px",
            "&:hover": { bgcolor: "grey.200" },
          }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
        </IconButton>

        <IconButton
          onClick={() => sliderRef.current.slickNext()}
          size="small"
          sx={{
            p: 0.5,
            bgcolor: "grey.100",
            borderRadius: "8px",
            "&:hover": { bgcolor: "grey.200" },
          }}
        >
          <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Box>

    </Box>
  );
};
